<template>
  <div class="mdl-grid">
    <edit-password v-show="editPassword" >
      <div class="link" v-on:click="editPassword = false">{{'profile.edit.button.editprofile' | label}}</div>
    </edit-password>
    <div v-show="!editPassword" class="mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp">
      <div class="ga-form-title">
        <h2 class="ga-title-text">{{'profile.edit.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div class="link" v-on:click="$set('editPassword', true)">{{'profile.edit.label.editpassword' | label}}</div>
        <validator name="editValidator" :groups="['firstLastOrNickGroup']">
          <form novalidate>
            <div class="mdl-grid">

              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label ga-required profile-label">
                  {{ 'profile.label.nickname' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                  <input class="mdl-textfield__input" type="text" readonly="readonly" id="nickname" v-model="user['nickname']" initial="off"
                         @touched="modified" v-validate:nickname="['required']">
                  <!--<label class="mdl-textfield__label" for="lastName">{{'profile.edit.label.nickname' | label}}</label>-->
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.required">{{'register.validation.nickname.required' | label}}</span>
                  <span class="validation-error mdl-textfield__error" v-if="showUsernameValidation">{{usernameValidationMessage | label}}</span>
                  <span class="ga-input-instruction" v-if="!$editValidator.nickname.required && !showUsernameValidation">{{'register.instruction.nickname' | label}}</span>
                </div> 
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label ga-required profile-label">
                  {{ 'profile.label.email' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                  <input class="mdl-textfield__input" type="text" id="email" v-model="user['email']" initial="off"
                         @touched="modified"  v-validate:email="['required', 'email']">
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.email.required && !showEmailValidation">
                    {{'register.label.email.validation' | label}}</span>
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.email.email && !showEmailValidation">{{'register.validation.email.format' | label}}</span>
                  <span class="validation-error mdl-textfield__error" v-if="showEmailValidation">{{emailValidationMessage | label}}</span>
                  <span class="ga-input-instruction" v-if="!$editValidator.email.required && !$editValidator.email.email && !showEmailValidation">{{'register.instruction.email' | label}}</span>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label ga-required profile-label">
                  {{ 'profile.label.confirmEmail' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                  <input class="mdl-textfield__input" type="text" id="confirmEmail" v-model="user['confirmEmail']" initial="off"
                        @touched="modified" v-validate:confirmemail="{isEqualEmail: getEmail, email: true}">
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.confirmemail.isEqualEmail">{{'register.validation.confirmEmail' | label}}</span>
                  <span class="validation-error mdl-textfield__error" v-if="!$editValidator.confirmemail.isEqualEmail && $editValidator.confirmemail.email">{{'register.validation.email.format' | label}}</span>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label ga-required profile-label">
                  {{ 'profile.label.firstName' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                  <input class="mdl-textfield__input" type="text" id="firstName" v-model="user['firstName']" initial="off"
                         group="firstLastOrNickGroup" @touched="modified" v-validate:firstName="{firstLastOrNick: getUser}">
                  <!--<label class="mdl-textfield__label" for="firstName">{{'profile.edit.label.firstName' | label}}</label>-->
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.firstLastOrNickGroup.invalid">{{'register.validation.firstLastOrNick' | label}}</span>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label ga-required profile-label">
                  {{ 'profile.label.lastName' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                  <input class="mdl-textfield__input" type="text" id="lastName" v-model="user['lastName']" initial="off"
                         group="firstLastOrNickGroup" @touched="modified" v-validate:lastName="{firstLastOrNick: getUser}">
                  <!--<label class="mdl-textfield__label" for="lastName">{{'profile.edit.label.lastName' | label}}</label>-->
                  <span class="validation-error mdl-textfield__error" v-if="$editValidator.firstLastOrNickGroup.invalid">{{'register.validation.firstLastOrNick' | label}}</span>
                </div>
              </div>

              <div class="mdl-cell mdl-cell--4-col">
                <div class="mdl-grid inner-grid">
                  <div class="mdl-cell mdl-cell--12-col">
                    <div class="form-label profile-label">
                      {{ 'profile.label.phone' | label }}
                    </div>
                  </div>
                </div>
                <!--<div class="profile-label">-->
                  <!--{{ 'profile.label.phone' | label }}-->
                <!--</div>-->
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                  <div class="mdl-cell mdl-cell--12-col padding-top">
                    <label v-el:noPhoneCheckbox class="mdl-checkbox mdl-js-checkbox ga-required" for="nophone">
                      <input type="checkbox" id="nophone" class="mdl-checkbox__input" name="nophone" checked="{{noPhone}}"
                             initial="off" v-model="noPhone">
                      <span class="mdl-checkbox__label">
                        {{'register.label.noPhone' | label}}
                      </span>
                      <span class="ga-input-instruction">{{'register.instruction.noPhone' | label}}</span>
                    </label>
                  </div>
                <!--<div class="profile-textfield mdl-textfield mdl-js-textfield fill">-->
                  <!--<input class="mdl-textfield__input" type="text" id="phone" v-model="user['phone']" initial="off">-->
                  <!--&lt;!&ndash;<label class="mdl-textfield__label" for="phone">{{'profile.edit.label.phone' | label}}</label>&ndash;&gt;-->
                  <!--&lt;!&ndash;<span class="validation-error mdl-textfield__error" v-if="$editValidator.phone.required">&ndash;&gt;-->
                    <!--&lt;!&ndash;{{'register.validation.phone' | label}}</span>&ndash;&gt;-->
                <!--</div>-->
                <div class="mdl-grid inner-grid">
                  <div class="mdl-cell mdl-cell--8-col">
                    <div v-el:phoneCodeEl class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
                      <!-- <input :disabled="noPhone ? true : null" class="mdl-textfield__input" type="number" id="phoneCode" v-model="phoneCode" initial="off"
                             v-validate:phoneCode="{phoneCode: getNoPhone}"> -->
                       <lookup-select id="phoneCode" name="phoneCode" 
                         :value.sync="phoneCode"
                         :lookup-object.sync="dialCode"
                         :clear.sync="clearPhoneCode"
                         options="DIAL_CODE" initial="off"
                         autocomplete
                         :disabled="noPhone"
                         :preselected="phoneCode"
                         v-el:phoneCodeSelectEl
                         v-validate:phoneCode="{phoneCode: getPhoneCode}"></lookup-select>
                       <label class="mdl-textfield__label" for="phoneCode">{{'register.label.phoneCode' | label}}</label>
                       <span class="validation-error mdl-textfield__error" v-if="$editValidator.phonecode.invalid && !noPhone">{{'register.validation.phoneCode' | label}}</span>
                       <span class="ga-input-instruction" v-if="!$editValidator.phonecode.phoneCode">{{'register.instruction.phoneCode' | label}}</span>
                    </div>
                  </div>
                  <div class="mdl-cell mdl-cell--4-col">
                    <div v-el:phoneNumberEl class="cell-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
                      <input :disabled="noPhone" class="mdl-textfield__input" type="number" id="phoneNumber" v-model="phoneNumber" initial="off"
                      @touched="modified"
                             v-validate:phoneNumber="{phoneNumber: getNoPhone}">
                      <label class="mdl-textfield__label" for="phoneNumber">{{'register.label.phone' | label}}</label>
                      <span class="validation-error mdl-textfield__error" v-if="$editValidator.phonenumber.invalid && !noPhone">{{'register.validation.phone' | label}}</span>
                      <span class="ga-input-instruction" v-if="!$editValidator.phonenumber.phoneNumber">{{'register.instruction.phoneNumber' | label}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label profile-label ga-required">
                  {{ 'profile.label.timeZone' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div style="padding-bottom: 20px;">
                  <lookup-select name='tz' :value.sync="user['timeZone']" options="TIME_ZONE" :preselected="user['timeZone']"></lookup-select>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--4-col">
                <div class="form-label profile-label ga-required">
                  {{ 'profile.label.language' | label }}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--8-col">
                <div style="padding-bottom: 40px;">
                  <lookup-select name='userLang' :value.sync="user['langCode']" options="LANG" :preselected="user['langCode']"></lookup-select>
                </div>
              </div>
            </div>
          </form>
        </validator>
        <div class="mdl-cell mdl-cell--12-col">
          <div class="mdl-grid inner-grid">
            <div class="mdl-cell mdl-cell--6-col">
              <div class="link" v-on:click="$dispatch('back')">{{'profile.edit.button.back' | label}}</div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                v-on:click="validate(user)">
                {{'profile.edit.button.submit' | label}}
              </div>
            </div>
          </div>
        </div>
      <!--</div>-->
      <div class="mdl-card__menu profile-edit">
        <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
            v-on:click="$dispatch('back')">
          <i class="material-icons">keyboard_arrow_left</i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
var api = require('api')
var makeDate = require('vue').filter('makeDate')
module.exports = {
  ready: function () {
    var self = this
    self.user = self.copyObject({}, self.loggedUser, {confirmEmail: self.loggedUser.email})
    if (self.user.phone) {
      self.phoneCode = (this.user.phone).split('-')[0]
      self.phoneNumber = (this.user.phone).split('-')[1]
    }
    self.noPhone = !self.user.phone
    window.componentHandler.upgradeAllRegistered()

    self.$nextTick(function () {
      document.querySelectorAll('.dirty-check').forEach(function (el) {
        var input = el.querySelector('input') || el.querySelector('textarea')
        if (input && input.value) {
          el.MaterialTextfield.checkDirty()
        }
      })
    })
  },
  components: {
    'datepicker': require('c/components/Datepicker'),
    langSelect: require('c/components/Select'),
    lookupSelect: require('c/components/Select'),
    editPassword: require('c/forms/EditPasswordForm')
  },
  props: {
    loggedUser: Object
  },
  methods: {
    validate: function (user) {
      var self = this
      api.User.available({
        username: user.nickname,
        email: user.email
      }).then(function (data) {
        self.submit()
      }, function (err) {
        if (err.data.message === 'register.error.usernameExists') {
          self.usernameValidationMessage = err.data.message
          self.showUsernameValidation = true
        } else if (err.data.message === 'register.error.emailExists') {
          self.emailValidationMessage = err.data.message
          self.showEmailValidation = true
        } else if (err.data.message === 'general.validation.error.emailFormat') {
          self.emailValidationMessage = err.data.message
          self.showEmailValidation = true
        } else {
          self.$dispatch('show-error', err.data)
        }
      })
    },
    submit: function () {
      var self = this
      this.$validate(true, function () {
        if (self.$editValidator.invalid) {
          return
        }
        if (!self.dialCode && !self.noPhone) {
          return
        }
        if (!self.noPhone) {
          self.user.prefix = self.dialCode.key
          self.user.phone = self.phoneCode + '-' + self.phoneNumber.replace(/^[0]+/g, '')
        } else {
          self.user.phone = null
          self.user.prefix = null
        }
        self.$dispatch('submitProfile', self.user)
      })
    },
    getEmail: function () {
      return {email: this.user.email}
    },
    getNoPhone: function () {
      return this.noPhone
    },
    getPhoneCode: function () {
      if (this.noPhone) {
        return true
      }
      return this.dialCode
    },
    modified: function () {
      this.$validate()
    },
    makeDate: function (date, timeZone, format) {
      return makeDate(date, timeZone, format)
    },
    getUser: function () {
      return this.user
    },
    copyObject: function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (source.hasOwnProperty(key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    },
    clearEmailValidation: function () {
      this.emailValidationMessage = ''
      this.showEmailValidation = false
    }
  },
  data: function () {
    return {
      editPassword: false,
      user: {},
      noPhone: true,
      phoneCode: '',
      phoneNumber: '',
      dialCode: undefined,
      clearPhoneCode: false,
      showUsernameValidation: false,
      usernameValidationMessage: '',
      showEmailValidation: false,
      emailValidationMessage: ''
    }
  },
  watch: {
    'noPhone': function (newVal, oldVal) {
      if (newVal) {
        this.clearPhoneCode = true
        this.phoneCode = ''
        this.phoneNumber = ''
        this.$els.phonecodeel.classList.remove('is-dirty')
        this.$els.phonecodeel.classList.add('is-disabled')
        this.$els.phonecodeselectel.classList.remove('is-dirty')
        this.$els.phonecodeselectel.classList.add('is-disabled')
        this.$els.phonenumberel.classList.remove('is-dirty')
        this.$els.phonenumberel.classList.add('is-disabled')
        this.$els.nophonecheckbox.classList.add('is-checked')
      } else {
        this.$els.phonecodeel.classList.remove('is-disabled')
        this.$els.phonecodeselectel.classList.remove('is-disabled')
        this.$els.phonenumberel.classList.remove('is-disabled')
        this.$els.nophonecheckbox.classList.remove('is-checked')
        this.clearPhoneCode = false
      }
    },
    'phoneCode': function (newVal, oldVal) {
      var self = this
      self.$validate('phonecode', true, function () {})
      if (newVal) {
        document.querySelectorAll('.dirty-check').forEach(function (el) {
          var input = el.querySelector('input') || el.querySelector('textarea')
          if (input && input.value) {
            el.MaterialTextfield.checkDirty()
          }
        })
      }
    },
    'dialCode': function (newVal, oldVal) {
      var self = this
      self.$validate('phonecode', true, function () {})
    }
  }
}
</script>

<style scoped>
  .profile-edit {
    top: 0px;
  }
  .profile-edit .mdl-button.mdl-button--icon {
    font-size: 32px;
    width: 48px;
    height: 48px;
  }
  .profile-edit .mdl-button.mdl-button--icon .material-icons {
    color: #F19100;
    font-size: 32px;
    left: 20px;
    top: 24px;
  }
</style>



// WEBPACK FOOTER //
// ProfileEditForm.vue?2419f8e6